import React, {
  createContext,
  useContext,
  useState,
  useMemo,
  PropsWithChildren,
} from 'react';

/* Providers */
import { usePaymentTypeContext } from './PaymentTypeContext';
import { useProductContext } from './ProductContext';

/* Interfaces */
import { Buyer, PaypalBuyer, PixBuyer, StripeBuyer } from '../interfaces/Buyer';
import { PaymentTypesReversed } from '../interfaces/payment_types';
import { connect } from 'react-redux';
import { RootState } from '../../../store';
import { LoginState } from '../../../store/login/reducer';
import { UserForPurchase } from '../interfaces/UserForPurchase';

interface BuyerContent {
  states: {
    buyer: Buyer;
    country: string;

    // setBuyer(buyer: Buyer): void;

    /* Stripe & Payal */
    email: string;
    setEmail: (email: string) => void;

    /* PIX */
    name: string;
    setName: (name: string) => void;
    documentNumber: string;
    setDocumentNumber: (documentNumber: string) => void;
  };
}
interface dispatchProps {
  loginState: LoginState;
}

export const BuyerContext = createContext<BuyerContent>({
  states: {
    buyer: {},
    country: '',
    // setBuyer: ({}) => ({}),

    /* Stripe & Paypal */
    email: '',
    setEmail: () => ({}),

    /* PIX */
    name: '',
    setName: () => ({}),
    documentNumber: '',
    setDocumentNumber: () => ({}),
  },
});

export const BuyerProvider: React.FC<dispatchProps & PropsWithChildren> = ({
  children,
  loginState,
}) => {
  const { product } = useProductContext();
  const { selectedPayment } = usePaymentTypeContext();
  const user = new UserForPurchase({
    ID: (loginState.user && loginState.user.user.id) || '',
    email: (loginState.user && loginState.user.user.email) || '',
    userName: '',
  });

  /* Stripe & Paypal */
  const [email, setEmail] = useState<string>(user.email);

  /* PIX */
  const [name, setName] = useState<string>(user.userName);
  const [documentNumber, setDocumentNumber] = useState<string>('');

  const buyer: Buyer = useMemo(() => {
    switch (selectedPayment) {
      case PaymentTypesReversed.Stripe:
        return new StripeBuyer(email);
      case PaymentTypesReversed.Paypal:
        return new PaypalBuyer(email);
      case PaymentTypesReversed.Pix:
        return new PixBuyer(name, documentNumber);
      default:
        return new StripeBuyer(email);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPayment, product, documentNumber]);

  const value = {
    states: {
      buyer,
      country: (loginState.user && loginState.user.user.country_code) || '',
      /* Stripe & Paypal */
      email,
      setEmail,

      /* PIX */
      name,
      setName,
      documentNumber,
      setDocumentNumber,
    },
  };

  return (
    <BuyerContext.Provider value={value}>{children}</BuyerContext.Provider>
  );
};

const mapStateToProps = (state: RootState) => ({
  loginState: state.login,
});

export const BuyerProviderConnected = connect(mapStateToProps)(BuyerProvider);

export const useBuyerContext = () => useContext(BuyerContext);
